var serverURL = 'https://sirenmarine.herokuapp.com'

$('document').ready(function(){
  
  var partnerName = getPartnerName();
  injectName(partnerName);
  initPartnerData(partnerName);
  
});

function getPartnerName(){
  var url = window.location.href;
  var urlArray = url.split('/');
  var partnerName = urlArray[urlArray.length-1];
  var nameArray = partnerName.split('partner-');
  var name = nameArray[1];
  return name;
}

function injectName(partnerName){
  $('.partner-name').text(partnerName).css('textTransform', 'capitalize');
}

function initPartnerData(partnerName){
  
  var partnerData = $.ajax({
    type: "GET",
    data: {
      name: partnerName
    },
    dataType: 'json',
    url: serverURL+'/v1/partner'
  });
  
  partnerData.done(function(data, textStatus) {
    $('.partner-email').text(data.email);
    $('.partner-phone').text(data.phone);
    $('.partner-website').text(data.website).attr('href', data.website);
  });
  
  partnerData.error(function(data, textStatus){
    console.log(textStatus);
  });
}